import React, { useEffect, useState } from "react";
import PageInfoAndActionBar from "../../../Layouts/PageInfoAndActionBar";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../../components/BuilderComponents/TableTreeModal";
import { useTableContext } from "../../../context/TableContext";
import NotesAndTags from "../../../components/BuilderComponents/NotesAndTags";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";

const ProgressBarRenderer = ({ applicationBlockData, handleSaveApplicationBlock }) => {
  const { currentBlockConfig, setCurrentBlockConfig, setApplicationBlockData } = useAppBlocksContext();
  const [isFieldModalOpen, setIsFieldModalOpen] = useState("");
  const [tableObj, setTableObj] = useState({});
  const { data, table_id } = currentBlockConfig;
  const { getTableTypeData } = useTableContext();
  const [showNotesModal, setShowNotesModal] = useState(false);

  const handleProgressBar = (value) => {
    const newProgressBarConfig = { ...currentBlockConfig };
    newProgressBarConfig.data.progress_type = value;
    setCurrentBlockConfig(newProgressBarConfig);
  };
  const selectFieldCallbackFunction = (data) => {
    const newcalendarConfig = { ...currentBlockConfig };
    newcalendarConfig.data.global_field_id = data.id;
    setCurrentBlockConfig(newcalendarConfig);
    setIsFieldModalOpen("");
  };

  const handleNotesAndTag = (data, keyName) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData[keyName] = data;
    setApplicationBlockData(copyBlockData);
  };

  const fetchTable = async () => {
    let { tableObject } = await getTableTypeData(applicationBlockData.table_type, table_id);
    setTableObj(tableObject);
  };
  useEffect(() => {
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const typeOptions = [
    { id: "linear", name: "Linear" },
    { id: "circular", name: "Circular" }
  ];
  return (
    <div>
      <PageInfoAndActionBar
        pagePath={`Progress Bar/${applicationBlockData.name}`}
        // clonePage={handleCloneApplicationBlock}
        savePage={handleSaveApplicationBlock}
        currentConfig={[currentBlockConfig, applicationBlockData]}
        pageName="applicationblock"
        notesPage={() => setShowNotesModal(!showNotesModal)}
        // saveOwner={() => setShowOwnerModal(!showOwnerModal)}
      />
      <div className="page_main_section">
        <div className="claender_View_outer" style={{ width: "300px" }}>
          <div className="builder_form">
            {/* <label className="builder_label">Select Progress Bar Type</label> */}
            <SingleSelectBox
              selectedData={data.progress_type || ""}
              options={typeOptions}
              onChange={(obj) => handleProgressBar(obj.id)}
              placeholder="Select type"
              label="Select Progress Bar Type"
            />
          </div>

          <div className="builder_form">
            <label className="builder_label">Select Global Field</label>
            <div className="builder_input w_100" onClick={() => setIsFieldModalOpen(true)}>
              {tableObj[data.global_field_id]?.display || "Select global field"}
              {/* {data.global_field_id || "Select global field"} */}
            </div>
          </div>
        </div>

        <BuilderModal isOpen={isFieldModalOpen} onClose={() => setIsFieldModalOpen("")} modalName="Select Field">
          <TableTreeModal
            callbackFunction={selectFieldCallbackFunction}
            tableId={table_id}
            folderId={["global_fields"]}
            preferredElements={["json"]}
            selectedFile={tableObj?.[data?.global_field_id]?.id || ""}
          />
        </BuilderModal>

        <BuilderModal isOpen={showNotesModal} onClose={() => setShowNotesModal(false)} modalName="Notes and Tags">
          <NotesAndTags
            notesValue={applicationBlockData.description || ""}
            tagValue={applicationBlockData.info_tag || []}
            onChange={handleNotesAndTag}
          />{" "}
        </BuilderModal>
      </div>
    </div>
  );
};

export default ProgressBarRenderer;
